import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import {
  animationValues,
  transitionValues,
} from "../../../utils/pageTransitions";
import Dropdown from "../../reusables/dropdown";
import { connect } from "react-redux";
import EditSupplierModal from "../../modals/editSupplierModal";
import Spinner from "../../reusables/spinner";
import {
  fetch_unapproved_suppliers,
  search_unapproved_suppliers,
} from "../../../redux/actions/adminActions";
import InputField from "../../reusables/input";
import DeleteModal from "../../modals/deleteModal";
import ApproveModal from "../../modals/approveModal";
import DeclineModal from "../../modals/declineModal";
import { periods, user_status } from "../../../utils/options";
import Pagination from "../../reusables/pagination";

function AwaitingApproval({
  next,
  searchUnapprovedSuppliers,
  unapprovedSuppliers,
  getUnapprovedSuppliers,
  accessToken,
}) {
  let filters = ["business_name", "phone_number", "email_address"];
  const [loading, setLoading] = useState(true);
  let token = accessToken;

  const success = () => {
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    getUnapprovedSuppliers(token, success);
  }, [getUnapprovedSuppliers, accessToken]);

  const [optionsActive, setOptions] = useState(null);

  const [filter, setFilter] = useState(filters[0]);

  const [deleteModal, setDelete] = useState({ modal: false, users: [] });

  const [edit, setEdit] = useState({ modal: false, user: null });

  const [approve, setApprove] = useState({ modal: false, users: [] });

  const [decline, setDecline] = useState({ modal: false, users: [] });

  const [suggestions, setSuggest] = useState([]);

  const [selectedSuppliers, setSelected] = useState([]);

  const handleOption = (id) => {
    if (optionsActive !== null) {
      setOptions(null);
    } else {
      setOptions(id);
    }
  };

  const handleSelect = (e) => {
    let updatedList = [...selectedSuppliers];
    if (e.target.checked) {
      updatedList = [...selectedSuppliers, Number(e.target.value)];
    } else {
      updatedList.splice(selectedSuppliers.indexOf(e.target.value), 1);
    }
    setSelected(updatedList);
  };

  const [search, setSearch] = useState("");

  const [selectedTime, setTime] = useState("All dates");
  const handleSelectTime = (Item) => {
    let filter = Item;
    setTime(Item);
    setLoading(true);
    getUnapprovedSuppliers(token, success, filter);
  };

  const handleSuggestions = (e) => {
    let results = [];

    setSuggest(results);
    setSearch(e.target.value.toLowerCase());

    unapprovedSuppliers.data.map((item) => {
      switch (filter) {
        case "business_name":
          let business_matches = item?.business_name.match(
            e.target.value.toLowerCase()
          );
          if (business_matches && results.length < 3) {
            results.push(business_matches?.input);
          }
          break;

        case "phone_number":
          let phone_matches = item?.phone_number.match(
            e.target.value.toLowerCase()
          );
          if (phone_matches && results.length < 3) {
            results.push(phone_matches?.input);
          }
          break;

        case "email_address":
          let email_matches = item?.email_address.match(
            e.target.value.toLowerCase()
          );
          if (email_matches && results.length < 3) {
            results.push(email_matches?.input);
          }
          break;

        default:
          break;
      }
    });
  };

  const searchHandler = (e) => {
    e.preventDefault();
    setLoading(true);
    searchUnapprovedSuppliers(accessToken, filter, search, success);
  };

  const resetSearch = () => {
    setSearch("");
    setLoading(true);
    getUnapprovedSuppliers(token, success);
  };

  const onPageChange = (page) => {
    setLoading(true);
    getUnapprovedSuppliers(token, success, page);
  };

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="pt-3">
        <div className="spaceBetween">
          <div className="searchHolder isRelative ">
            <div className="alignOnly">
              <Dropdown value={filter} className="mx-1">
                {filters.map((item) => (
                  <div
                    className="isClickable hoverGreen"
                    onClick={() => setFilter(item)}
                  >
                    <p className="sectionText px-3 py-2 mb-0">{item}</p>
                  </div>
                ))}
              </Dropdown>
              <InputField
                inputClass="mx-1"
                iconClick={searchHandler}
                value={search}
                onChange={handleSuggestions}
                placeholder={`Search by ${filter}`}
                icon
                iconClass="ri-search-line"
              />

              {search !== "" && (
                <span
                  className="isRed sectionText--small mx-2 isClickable"
                  onClick={resetSearch}
                >
                  Clear Filter
                </span>
              )}
            </div>

            {suggestions?.length > 0 && (
              <div className="suggestions_holder isRelative">
                <div className="suggestions">
                  {suggestions?.map((item) => (
                    <div
                      className="isClickable hoverGreen"
                      onClick={() => {
                        setSearch(item);
                        setSuggest([]);
                      }}
                    >
                      <p className="sectionText px-3 py-2 mb-0">{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>

          <div className="alignOnly pt-2">
            <button
              className={`btn__filled ${
                !selectedSuppliers.length > 0 && "btn__disabled"
              } hasRadius mx-1`}
              disabled={!selectedSuppliers.length > 0}
              onClick={() => {
                setApprove({ modal: true, users: selectedSuppliers });
              }}
            >
              Approve
            </button>

            {/* <button
              className={`btn__filled ${
                !selectedSuppliers.length > 0 && "btn__disabled"
              } hasRadius mx-1`}
              disabled={!selectedSuppliers.length > 0}
              onClick={() => {
                setDecline({ modal: true, users: selectedSuppliers });
              }}
            >
              Decline
            </button> */}

            <button
              className={`btn__red ${
                !selectedSuppliers.length > 0 && "btn__disabled"
              } hasRadius mx-1`}
              disabled={!selectedSuppliers.length > 0}
              onClick={() => {
                setDelete({
                  modal: true,
                  users: [...deleteModal.users, ...selectedSuppliers],
                });
              }}
            >
              Delete
            </button>

            <div className="alignOnly pt-2">
              <Dropdown value={selectedTime} className="mx-1">
                {periods?.map((item) => (
                  <div
                    className="isClickable hoverGreen"
                    onClick={() => handleSelectTime(item)}
                  >
                    <p className="sectionText px-3 py-2 mb-0">{item}</p>
                  </div>
                ))}
              </Dropdown>
            </div>
          </div>
        </div>

        <div className="fullHeight scrollable--mobile py-5">
          {!loading ? (
            unapprovedSuppliers?.data.length > 0 ? (
              <table className="table table__custom">
                <thead className="sectionText--small textIsGray table__head pb-2">
                  <tr className="">
                    <th className="">Business Name</th>
                    <th className="vAlign">Manager’s Name</th>
                    <th className="vAlign">Mobile</th>
                    <th className="vAlign">Email</th>
                    <th className="vAlign">Address</th>
                    <th className="vAlign">Date</th>
                    <th className="vAlign">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {unapprovedSuppliers?.data.map((item) => (
                    <tr className="hasRadius">
                      <td className="alignOnly">
                        <input
                          type="checkbox"
                          className="isClickable"
                          value={item.id}
                          onChange={handleSelect}
                          id=""
                        />

                        <div className="mx-1 alignOnly">
                          <div className="supplier__image mx-2">
                            <img
                              src={item?.photograph}
                              className="w-100"
                              alt=""
                            />
                          </div>

                          <p className="mb-0 textIsBold sectionText">
                            {item?.business_name}
                          </p>
                        </div>
                      </td>

                      <td className="pt-4 vAlign">
                        <p className="mb-0  sectionText">
                          {item?.manager_name}
                        </p>
                      </td>

                      <td className="pt-4 vAlign">
                        <p className="mb-0  sectionText">
                          {item?.phone_number}
                        </p>
                      </td>

                      <td className="vAlign pt-4">
                        <p className="mb-0 sectionText">
                          {item?.email_address}
                        </p>
                      </td>

                      <td className="vAlign pt-4 address">
                        <p className="mb-0 sectionText">
                          {item?.business_address}
                        </p>
                      </td>

                      <td className="vAlign pt-4">
                        <p className="mb-0  sectionText">{item?.date}</p>
                      </td>

                      <td className="vAlign pt-4">
                        <i
                          class="ri-more-line isClickable"
                          onClick={() => handleOption(item.id)}
                        ></i>

                        {optionsActive === item.id && (
                          <div className="options">
                            <div className="caret"></div>
                            <div className="p-2 textIsBold lAlign sectionText--small">
                              <div
                                className="hasBorder--bottom pb-2"
                                onClick={() =>
                                  setEdit({
                                    ...edit,
                                    modal: true,
                                    user: item,
                                  })
                                }
                              >
                                Edit
                              </div>
                              <p
                                className="hasBorder--bottom py-2 mb-0"
                                onClick={() =>
                                  setApprove({
                                    ...approve,
                                    modal: true,
                                    users: [...approve.users, item.id],
                                  })
                                }
                              >
                                Approve
                              </p>
                              {/* <p
                                className="hasBorder--bottom py-2 mb-0"
                                onClick={() =>
                                  setDecline({
                                    ...decline,
                                    modal: true,
                                    users: [...decline.users, item.id],
                                  })
                                }
                              >
                                Decline
                              </p> */}
                              <p
                                className="isRed py-2 mb-0"
                                onClick={() =>
                                  setDelete({
                                    ...deleteModal,
                                    modal: true,
                                    users: [...deleteModal.users, item.id],
                                  })
                                }
                              >
                                Delete
                              </p>
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="w-100 sectionHeight--mid center pt-4">
                <h2 className="sectionHead--small textIsBold textIsGreen">
                  No supplier found
                </h2>
              </div>
            )
          ) : (
            <div className="text-center mx-auto mt-4">
              <Spinner big />
            </div>
          )}
          <div className="d-flex justify-content-end">
            <Pagination
              onChange={onPageChange}
              page={unapprovedSuppliers?.current_page}
              total={unapprovedSuppliers?.total}
              per_page={unapprovedSuppliers?.per_page}
            />
          </div>
        </div>
      </div>
      <EditSupplierModal
        unapproved
        show={edit.modal}
        user={edit.user}
        handleClose={() => setEdit({ ...edit, modal: false })}
      />
      <DeleteModal
        supplier
        unapproved
        show={deleteModal.modal}
        users={deleteModal.users}
        handleClose={() =>
          setDelete({
            ...deleteModal,
            modal: false,
          })
        }
      />
      <ApproveModal
        show={approve.modal}
        users={approve.users}
        handleClose={() =>
          setApprove({
            ...approve,
            modal: false,
          })
        }
      />
      <DeclineModal
        users={decline.users}
        show={decline.modal}
        handleClose={() =>
          setDecline({
            ...decline,
            modal: false,
          })
        }
      />
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  unapprovedSuppliers: state.admin.suppliers.unapproved,
  accessToken: state.admin.token,
});

const mapDispatchToProps = (dispatch) => ({
  getUnapprovedSuppliers: (token, success, filter, page) =>
    dispatch(fetch_unapproved_suppliers(token, success, filter, page)),
  searchUnapprovedSuppliers: (token, type, value, success) =>
    dispatch(search_unapproved_suppliers(token, type, value, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AwaitingApproval);
